import { render, staticRenderFns } from "./EditRoomType.vue?vue&type=template&id=44788425&scoped=true&"
import script from "./EditRoomType.vue?vue&type=script&lang=js&"
export * from "./EditRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44788425",
  null
  
)

export default component.exports